//import axios from "axios";
import axiosInstance from "../interceptors/axiosInterceptor";
import { makeRequest } from "./api";

export const loginUser = async (email, password, role) => {
  try {
    const response = axiosInstance.post(
      `${process.env.REACT_APP_BASE_URL}/api/auth/login`,
      {
        email,
        password,
        role,
      },
    );

    return response;
  } catch (error) {
    throw new Error("Failed to logging in. Please try again later.");
  }
};

export const GenerateShortToken = async () => {
  return makeRequest("/api/auth/generate-short-token", {
    method: "POST",
  });
};
